import { TrendingUp, TrendingDown } from "lucide-react";

export default function KpiCard({
  label,
  value,
  sub,
  icon: Icon,
  accent = "deep",
  trend,
  testId,
}) {
  const accentMap = {
    deep: "bg-[#0A3D91]/8 text-[#0A3D91]",
    blue: "bg-[#0E73C9]/10 text-[#0E73C9]",
    cyan: "bg-[#18B7D8]/12 text-[#18B7D8]",
    teal: "bg-[#1CC7B3]/12 text-[#0B8F80]",
  };
  return (
    <div className="card-harmony p-5 flex flex-col" data-testid={testId}>
      <div className="flex items-start justify-between">
        <div className="text-xs font-medium uppercase tracking-wider text-slate-500">{label}</div>
        {Icon && (
          <div className={`h-9 w-9 rounded-lg flex items-center justify-center ${accentMap[accent]}`}>
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      <div className="font-display text-2xl lg:text-[1.7rem] font-bold text-slate-900 mt-3 leading-tight">
        {value}
      </div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
      {trend != null && (
        <div
          className={`mt-3 inline-flex items-center gap-1 text-xs font-medium ${
            trend >= 0 ? "text-emerald-600" : "text-rose-600"
          }`}
        >
          {trend >= 0 ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
          {Math.abs(trend).toFixed(1)}% vs TV only
        </div>
      )}
    </div>
  );
}
